import { render, staticRenderFns } from "./Teatros.vue?vue&type=template&id=4bbf0f58"
import script from "./Teatros.vue?vue&type=script&lang=js"
export * from "./Teatros.vue?vue&type=script&lang=js"
import style0 from "./Teatros.vue?vue&type=style&index=0&id=4bbf0f58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports